<div class="banner p-vx2 f-ac f-jc f-w" v-if="banner.visible" :class="banner.data.bgColor"><component :is="banner.type"></component></div>